export default __webpack_public_path__ + "static/media/heroLady.1f03f9d2.jpg";